module.exports = __webpack_public_path__ + "static/drawerfooterimage-aaf37e5adf1e245db64895b9296158e9.jpg";